angular.module('trainerWebApp.controllers')
  .controller('TrackPageCtrl', ['$scope', '$location', '$timeout', 'trackingService', 'actionLogResource', 'mtypes', '$window', '$modal', function ($scope, $location, $timeout, trackingService, actionLogResource, mtypes, $window, $modal) {
    var gaActions = trackingService.pages.getStarted.actions;
    var scheduleDemoUrl = 'https://laurenl.youcanbook.me/?' +
      'FIRSTNAME=' + $window.mfConfig.userFirstName + '&' +
      'LASTNAME=' + $window.mfConfig.userLastName + '&' +
      'EMAIL=' + $window.mfConfig.userEmail + '&' +
      'PHONE=' + $window.mfConfig.accountPhoneNumber + '&' +
      'COMPANY=' + $window.mfConfig.accountName;

    $scope.goToTrainerHome = function () {
      trackGS(gaActions.GettingStartedTrackPage_GetStartedButton);
      $location.path('/TMS/Home');
    };

    $scope.scheduleDemo = function () {
      $modal.open({
        template: '<iframe src="' + scheduleDemoUrl + '" width="556px" height="600px"></iframe>'
      });
      actionLogResource.writeActionLog([{action: mtypes.actionType.gettingStartedTourTrackPage}]);
    };

    function trackGS(eventName) {
      trackingService.trackEvent(trackingService.pages.getStarted.name, eventName);
    }

    var findZendeskWidgetPromise = null;
    var zendeskWidget = null;
    function findZendeskWidget() {
      findZendeskWidgetPromise = $timeout(function () {
        zendeskWidget = angular.element('#launcher');
        if (!zendeskWidget || zendeskWidget.length == 0)
          return findZendeskWidget();
        zendeskWidget.css('visibility', 'hidden');
        $timeout.cancel(findZendeskWidgetPromise);
      }, 250);
    }

    var findIntercomWidgetPromise = null;
    var intercomWidget = null;
    function findIntercomWidget() {
      findIntercomWidgetPromise = $timeout(function () {
        intercomWidget = angular.element('#intercom-container');
        if (!intercomWidget || intercomWidget.length == 0)
          return findIntercomWidget();
        intercomWidget.css('display', 'inline');
        $timeout.cancel(findIntercomWidgetPromise);
      })
    }

    $scope.$on('$destroy', function () {
      $timeout.cancel(findZendeskWidgetPromise);
      $timeout.cancel(findIntercomWidgetPromise);
      if (zendeskWidget)
        zendeskWidget.css('visibility', 'visible');
      if (intercomWidget)
        intercomWidget.css('display', 'nonen');
    });

    trackGS(gaActions.GettingStartedTrackPage);
    actionLogResource.writeActionLog([{action: mtypes.actionType.gettingStartedTourTrackPage}]);
    findZendeskWidget();
    findIntercomWidget();
  }]);
